import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { parse, format } from 'date-fns';
import Chip from '@mui/material/Chip';
import {
    Popover,
    FormLabel,
    RadioGroup,
    Radio,
    IconButton,
} from "@mui/material";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import api from '../../../../../../services/api';
import MenuRecursosFrota from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import AnexadorArquivos from "../../../../../../components/AnexadorArquivos";
import { useParams } from 'react-router-dom';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));




export default function CadastrarCombustivel({ flag, veiculo, atribuicao, closeNovoCombustivel, closeAtualizarCombustivel, combustivelAtualizar }) {

    function formatarDataBR(dateObj) {
        let dia = String(dateObj.getDate()).padStart(2, '0');
        let mes = String(dateObj.getMonth() + 1).padStart(2, '0');
        let ano = dateObj.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

  const [idCombustivelSalva, setIdCombustivelSalva] = useState(0);
    const anexadorRef = useRef();

    const classes = useStyles();
    const history = useHistory();

    const [descricao, setDescricao] = useState(flag === 0 ? "" : combustivelAtualizar.descricao);



    const [loading, setLoading] = useState(false);



    //  formatarDataBR(new Date( atribuicaoAtualizar.data_devolucao))

    const [data, setData] = useState(flag === 0 ? '' : formatarDataBR(new Date(combustivelAtualizar.data)));
    const [hora, setHora] = useState(flag === 0 ? '' : combustivelAtualizar.hora);



    const [odometro, setOdometro] = useState(flag === 0 ? 0.0 : combustivelAtualizar.odometro);

    const [litros, setLitros] = useState(flag === 0 ? 0.0 : combustivelAtualizar.litros);

    const [tipoCombustivel, setTipoCombustivel] = useState(flag === 0 ? 0.0 : combustivelAtualizar.tipo_combustivel);
    const [quantidade, setQuantidade] = useState(flag === 0 ? 0.0 : combustivelAtualizar.quantidade);
    const [valorQuantidade, setValorQuantidade] = useState(flag === 0 ? 0.0 : combustivelAtualizar.valor_quantidade);

    


    useEffect(() => {

    }, []);


    
        useEffect(() => {
            if (idCombustivelSalva > 0 && anexadorRef.current) {
                anexadorRef.current.salvarArquivos();
            }
        }, [idCombustivelSalva]);


    function returnDescricaoColaborador(colaborador) {


        var texto = "Colaborador_ID: " + colaborador.id_colaborador +
            "\nCPF: " + colaborador.cpf +
            "\nNome: " + colaborador.nome + " " + colaborador.sobrenome + "\n ";
        return texto;
    }





    function isNumeroValido(valor) {
        return valor !== "" && valor !== null && !isNaN(Number(valor));
    }


    async function salvar() {


        try {


            if (!isNumeroValido(odometro)) {
                alert("Insira o odômetro inicial");
                return;
            }


            if (!isNumeroValido(valorQuantidade)) {
                alert("Insira o Valor do Litro");
                return;
            }

                if (!isNumeroValido(quantidade)) {
                alert("Insira a quantidade abastecida");
                return;
            }

               if (!isNumeroValido(litros)) {
                alert("Insira a quantidade de combustível no tanque antes do abastecimento");
                return;
            }


            console.log("cadastrar chamado");
            const cadastro = {
                atribuicao_id: atribuicao.id_atribuicao,
                usuario_criador: { id_usuario: Cookies.get('id_usuario') },
                odometro: parseFloat(odometro),
                litros: parseFloat(litros),
                quantidade: parseFloat(quantidade),
                valor_quantidade: parseFloat(valorQuantidade),
                tipo_combustivel: tipoCombustivel,
                descricao: descricao,
                valor_total: parseFloat(valorQuantidade) * parseFloat(quantidade),

            };

            if (data && parse(data, 'dd/MM/yyyy', new Date()) instanceof Date) {

                cadastro.data = format(parse(data, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
            } else {
                alert("Informe uma data válida!");
                return;
            }

            if (hora && parse(hora, 'HH:mm', new Date()) instanceof Date) {

                cadastro.hora = format(parse(hora, 'HH:mm', new Date()), 'HH:mm');
            } else {
                alert("Informe uma hora válida!");
                return;
            }





            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/veiculos/combustivel/cadastrar', cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
               // closeNovoCombustivel();
               // alert("Abastecimento Cadastrado!");
                    //cadastrar arquivos
              setIdCombustivelSalva(cadastro_salvo.id_combustivel);
               
               
               

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde " + _err);

        }



    }











    return (
        <>
            {!loading &&
                <Grid container spacing={2}   >
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        {flag === 0 && (
                            <Button style={{ margin: 5 }}
                                variant="contained"
                                color="primary"
                                onClick={salvar}
                            > Salvar  </Button>
                        )}

                        
                    </Grid>

                    <Grid item xs={12}
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                    >



                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"

                        >

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="data"
                                    label="Data"
                                    id="data"
                                    value={data}
                                    onChange={(e) => setData(e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="hora"
                                    label="Hora"
                                    id="hora"
                                    value={hora}
                                    onChange={(e) => setHora(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="odometro"
                                    label="Odómetro Atual"
                                    id="odometro"
                                    value={odometro}
                                    onChange={(e) => setOdometro(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                          

                            <Grid container   alignItems="center">
                            
                                {/* CAMPO NUMÉRICO */}
                                <Grid item xs={3} style={{ padding: 5 }}>
                                    <TextField
                                        variant="standard"
                                        label="Combustível no Tanque (0 a 8)"
                                        type="number"
                                        inputProps={{
                                            min: 0,
                                            max: 8,
                                            step: 0.1
                                        }}
                                        value={litros}
                                        onChange={(e) => {
                                            let v = Number(e.target.value);
                            
                                            if (v < 0) v = 0;
                                            if (v > 8) v = 8;
                            
                                            setLitros(v);
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            
                                {/* EQUAÇÃO + RESULTADO */}
                                <Grid item xs={9}>
                                    <Typography variant="body2" color="textSecondary">
                                        {veiculo.capacidade_combustivel} × {litros}/8
                                    </Typography>
                            
                                    <Typography variant="h6">
                                        {(
                                            veiculo.capacidade_combustivel * (litros/8)
                                        ).toFixed(2)} litros no tanque
                                    </Typography>
                                </Grid>
                             </Grid>

                        </Grid>



                        <Grid item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                        >


                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="tipoCombustivel-label">Tipo Combustível</InputLabel>
                                    <Select
                                        labelId="tipoCombustivel-label"
                                        id="tipoCombustivel"
                                        value={tipoCombustivel}
                                        onChange={(e) => setTipoCombustivel(e.target.value)}
                                        label="Tipo Combustível"
                                    >
                                        <MenuItem value={0}>Gasolina Comum</MenuItem>
                                        <MenuItem value={10}>Gasolina Aditivada</MenuItem>
                                        <MenuItem value={20}>Etanol</MenuItem>
                                        <MenuItem value={30}>Diesel S10</MenuItem>
                                        <MenuItem value={40}>Diesel S500</MenuItem>
                                        <MenuItem value={50}>GNV</MenuItem>

                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="valorQuantidade"
                                    label="Valor por Quantidade"
                                    id="valorQuantidade"
                                    value={valorQuantidade}
                                    onChange={(e) => setValorQuantidade(e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="quantidade"
                                    label="Quantidade Abastecida"
                                    id="quantidade"
                                    value={quantidade}
                                    onChange={(e) => setQuantidade(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="valorTotal"
                                    label="Valor Total"
                                    id="valorTotal"
                                    value={(Number(quantidade) || 0) * (Number(valorQuantidade) || 0)}
                                    fullWidth
                                />
                            </Grid>





                        </Grid>





                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                name="descricao"
                                label="Descrição"
                                id="descricao"
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value)}
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </Grid>







                    </Grid>




  <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{ marginTop: 5 }}
                    >
                        <AnexadorArquivos
                            ref={anexadorRef}
                            flag={flag}
                            isCombustivel={true}
                            objeto={flag === 1 ? combustivelAtualizar : null}
                            id={flag === 1 ? combustivelAtualizar.id_combustivel : idCombustivelSalva}
                            close={closeNovoCombustivel}

                        />
                    </Grid>



                </Grid>
            }




        </>
    );
}


